import axios from 'axios'
import {to} from './utils'

export default {
  async getNotices () {
    return to(axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/${process.env.VUE_APP_API_VERSION}/notices`))
  }
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/endpoints/notices.js
// module id = null
// module chunks = 